module.exports = __webpack_public_path__ + "static/media/wall.31400ab9.png";